import { WebPageCrashFallback } from '@features/misc/routes/WebPageCrashFallback'
import { useEffect } from 'react'
import { useRouteError } from 'react-router'
import image from 'shared-ui/assets/new_feature_popup-01.svg'
import { PanoramaButton } from 'shared-ui/components'
import { useDebug } from 'shared-ui/debug'
import { useLocalization } from 'shared-ui/localization'
import { isDynamicImportError } from 'utils'

export const RouteLevelErrorComponent = () => {
  const { t } = useLocalization()
  const error = useRouteError()
  const { logError } = useDebug()

  useEffect(() => {
    if (!isDynamicImportError(error)) logError(error)
  })

  const refreshPage = () => {
    location.reload()
  }

  if (isDynamicImportError(error))
    return (
      <div className="mx-auto mt-10 flex max-w-lg flex-col items-center justify-center gap-8 md:flex-row lg:mt-24">
        <img src={image} alt="" className="max-h-72" />
        <div className="flex w-64 flex-col gap-4">
          <h2 className="pan-title2">{t(($) => $['good-news'])}</h2>

          <p className="pan-body-large">{t(($) => $['we-have-updated-the-app'])}</p>
          <PanoramaButton onClick={refreshPage}>{t(($) => $.labels.refresh)}</PanoramaButton>
        </div>
      </div>
    )

  if (error instanceof Error) return <WebPageCrashFallback error={error} />

  return <WebPageCrashFallback error={new Error(JSON.stringify(error))} />
}
